import { UserQuote } from '@modules/oracle/components/UserQuote/UserQuote';
import { UserQuotesFooter } from '@modules/oracle/components/UserQuotes/UserQuotes/UserQuotesFooter';
import {
  UserQuotesByExampleID,
  UserQuoteTokensByResponseID,
} from '@modules/oracle/types';
import { Paper, Stack } from '@mui/material';
import { FeedbackSummaryExample } from 'generated/graphql';
import { useState } from 'react';
import { createAnalyticsTracker } from 'v2/analytics/events';

const trackFeedbackListSummaryEvents = createAnalyticsTracker(
  'feedbackListSummary',
);

interface UserQuotesProps {
  sessionID: string;
  labelID?: string;
  feedbackSummaryExample: FeedbackSummaryExample;
  userQuoteTokensByResponseID: UserQuoteTokensByResponseID;
  userQuotesByExampleID: UserQuotesByExampleID;
}

export function UserQuotes({
  labelID: labelIDProp,
  sessionID,
  feedbackSummaryExample,
  userQuotesByExampleID,
  userQuoteTokensByResponseID,
}: UserQuotesProps) {
  const [currentRecordIDIndex, setCurrentRecordIDIndex] = useState(0);

  const onNextClick = () => {
    setCurrentRecordIDIndex(currentRecordIDIndex + 1);
    trackFeedbackListSummaryEvents({
      eventName: 'Feedback List Summary - User Quote Next Button Clicked',
    });
  };

  const onPreviousClick = () => {
    setCurrentRecordIDIndex(currentRecordIDIndex - 1);
    trackFeedbackListSummaryEvents({
      eventName: 'Feedback List Summary - User Quote Previous Button Clicked',
    });
  };

  const recordID =
    (feedbackSummaryExample.labelExample
      ? feedbackSummaryExample.labelExample?.recordIDs[currentRecordIDIndex]
      : feedbackSummaryExample.claimExample?.records[currentRecordIDIndex]
          ?.recordID) ?? '';

  const labelID =
    labelIDProp ??
    feedbackSummaryExample.claimExample?.records.find(
      (recordObj) => recordObj.recordID === recordID,
    )?.labelID;

  return (
    <Stack component={Paper} elevation={2}>
      <UserQuote
        key={recordID}
        feedbackSummaryExample={feedbackSummaryExample}
        labelID={labelID}
        recordID={recordID}
        sessionID={sessionID}
        userQuotesByExampleID={userQuotesByExampleID}
        userQuoteTokensByResponseID={userQuoteTokensByResponseID}
      />
      <UserQuotesFooter
        currentQuoteNumber={currentRecordIDIndex + 1}
        proofCount={feedbackSummaryExample.count}
        onNextClick={onNextClick}
        onPreviousClick={onPreviousClick}
      />
    </Stack>
  );
}
